package pt.at.oss.kotlin.manual.validator.common

import pt.at.oss.kotlin.manual.enumeration.CustomErrorCodes
import pt.lightweightform.kotlin.type.validator.ValidationError

/**
 * Created by Pedro Alfaiate on 14/05/2020.
 */
object TradingNamesValidator {
    val tradingNamesValidate = fun(tradingNamesSize: Int, companyName: String): ValidationError? {
        // helpful tip: Specifying one tradingName instead of a companyName
        return if (companyName.isBlank() && tradingNamesSize > 0) ValidationError(CustomErrorCodes.HAVE_TRADING_NAMES_BUT_NO_COMPANY_NAME.code)
        else null
    }
}
